<!-- Admin Edit Article Pix -->

<template>
	<div class="adm-edit-pix">

		<div v-if="current.pix.length==0">
			No images for this record
		</div>

		<div v-for="(rec, idx) in current.pix" :key="'pic'+idx">
			<AdmEditPixDetail
				:rec="rec"
				:idx="idx"
			/>

			<div class="v-spacer" />
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex';
import AdmEditPixDetail from '@/components/AdmEditPixDetail';

export default {
	components: {
		AdmEditPixDetail,
	},
	computed: {
		...mapState('app', ['current']),
	},
}
</script>

<style scoped>

.adm-edit-pix {
	height: 100%;
	overflow: auto;
	border: solid 0px #C30;
}

.v-spacer {
	width: 10px;
	height: 5px;
	border: solid 0px #999;
}

</style>
